var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "s-news-nav"
  }, [_c('div', {
    staticClass: "s-basis-1/4"
  }, [_c('button', {
    staticClass: "s-news-btn ml-3 pl-3 pr-3",
    on: {
      "click": _vm.back
    }
  }, [_vm._v("返回")])]), _c('div', {
    staticClass: "text-center s-basis-1/2"
  }, [_vm._v(_vm._s(_vm.news.title))])]), _vm.fetching ? _c('p', [_c('Loading')], 1) : [_c('div', {
    staticClass: "news m-3 s-bg-white s-px-3 s-py-5"
  }, [_c('div', {
    staticClass: "news__title"
  }, [_vm._v(_vm._s(_vm.news.title))]), _vm.news__subtitle ? _c('div', {
    staticClass: "news__subtitle"
  }, [_vm._v(_vm._s(_vm.news.subtitle))]) : _vm._e(), _c('img', {
    staticClass: "w-100 s-py-5",
    attrs: {
      "src": _vm.news.image_url
    }
  }), _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.news.content)
    }
  })])]], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }